'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support transform prop syntax.
// https://caniuse.com/#search=transform
exports['default'] = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;
    if (options.transform) {
      return prop;
    }
    return _prefix2['default'].css + prop;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/transform.js
// module id = 19
// module chunks = 0